module.exports = __webpack_public_path__ + "static/img/dashboard2.aafeb5c6.png";